import { createActions } from 'redux-actions';

export default createActions(
  {
    INIT: (robotId) => ({ robotId }),
    SET_FC: (robotId, data) => ({ robotId, data }),
    SET_PAYLOAD: (robotId, name, data) => ({ robotId, name, data }),
    REMOVE: (robotId) => ({ robotId }),
  },
  { prefix: 'ADDRESS' },
);
